import {Injectable} from '@angular/core'
import {Subject, BehaviorSubject} from 'rxjs/Rx'

import { AngularFireDatabase } from 'angularfire2/database';

import { Observable } from 'rxjs/Observable';

//import FirebaseService from '../services/firebase.service'

//import Provider from '../models/provider.model' //moche ici


//import Post from '../models/post.model'
//import User from '../models/user.model'

@Injectable()
export class PostService {
  //currentPost: Subject<Post> = new BehaviorSubject<Post>(null)
  
  filteredPosts: Observable<any[]>;
  rootRef: any;

  date: Date;
  num: number;

  constructor(
    //firebaseService: FirebaseService, 
    public af: AngularFireDatabase
  ) {
    //this.rootRef = firebaseService.rootRef
    //this.af = af
  }

  createNewPost(post, options, coverageStatut, setstatut, topic, photo, tag, sethumeur) {
    return new Promise((resolve, reject) => {
      //const {user, content} = options
      let id = post.$key    
      const data2 = post
      //const coverageStatut = coverageStatut
      //console.log(coverageStatut)
      //const topic = topic
      const statut = setstatut
      const humeur = sethumeur
     
     this.rootRef='test';
      
      delete post.$key 
      
      if(!tag) tag = null;
      
      //var date = new Date();
      var date = date.getTime()
      
      


      //var order = 1000000000000-date;
      var content = {description: options, title: options, text: options}
      
      
      const data = {
        //coverage: 'cove',
        type: 'statut',
        //humeur: humeur,
        statut: statut,
        created_at: date,
        //type: topic,
        content: content,
        post: post,
        tag: tag,
        date: date,
        //order: order
      }
      
      if(photo) data2['photo'] = true
      //console.log(data2)
      if(statut) {
        data2['statut'] = statut
         if(!statut.type) statut.type = 'default';
         if(!statut.cat) statut.cat = 'default';
      }
      
        this.rootRef
        .child('coverage-feed')
        .child(128)
        //.child(datenow)
        .child('aware')
        .child(id)
        //.child('favorites')
        .set(data2)

      var coverage = post.coverage;
      for (num in coverage){
        
        
        
        //console.log(statut)
        if(coverage[num].type != 'tag')
        this.rootRef
        .child('coverage-feed')
        .child(coverage[num].id)
        //.child(datenow)
        .child('aware')
        .child(id)
        //.child('favorites')
        .set(data2)
        
      
        
      
      }
    
    
    
    var coverage = coverageStatut;
    if(statut)
      {
        
        
              var num;
              for (num in coverage){
                
              
                
                if(coverage[num].type != 'tag')  
                {
                
                  if(humeur) {
                    
                    this.rootRef
                    .child('coverage-type')
                    .child(coverage[num].type)
                    .child(coverage[num].id)
                    .child('statut')
                    .child('humeur')
                    .set(humeur)

                    this.rootRef
                    .child('coverage')
                    .child(coverage[num].id)
                    .child('statut')
                    .child('humeur')
                    .set(humeur)
                    
                  }
                  
                  this.rootRef
                  .child('coverage-type')
                  .child(coverage[num].type)
                  .child(coverage[num].id)
                  .child('statut')
                  .child(statut.type)
                  .set(data)

                  this.rootRef
                  .child('coverage')
                  .child(coverage[num].id)
                  .child('statut')
                  .child(statut.type)
                  .set(data)
                  
                        //var order = 1000000000000-date;

                  this.rootRef
                  .child('coverage')
                  .child(coverage[num].id)
                  .child('last_update')
                  //.child(statut.type)
                  .set(date)
                  
                  this.rootRef
                  .child('coverage-type')
                  .child(coverage[num].type)
                  .child(coverage[num].id)
                  .child('last_update')
                  //.child(statut.type)
                  .set(date)
                    
                
                
                
                // add topic
                const postRef = this.rootRef
                .child('coverage-feed')
                .child(coverage[num].id)
                //.child(datenow)
                .child('statut').push()
                
                postRef.set(data, error => {
                  if (error) {
                    reject()
                  } else {
                    resolve()
                  }
                })
                
              
              }
            }
    
    } else resolve();
      
      
    })
  }

  allPosts(): Subject<any[]> {
    const postsObservable = new BehaviorSubject<any[]>(null)

    /*this.rootRef.child('feed')
      //.orderByChild('type')
      //.equalTo('dailymotion')
      .limitToLast(30)
      .on('value', snapshot => {
      const data = snapshot.val()
      const posts = Object.keys(data)
        .map(id => new Post(id, data[id]))
        .sort((lhs, rhs) => rhs.date.getTime() - lhs.date.getTime())

      postsObservable.next(posts)
    }*/

    return postsObservable
  }


  providersForUser(uid, type): Subject<any[]> {
    const postsObservable = new BehaviorSubject<any[]>(null)

    /*this.rootRef
      .child('coverage-data')
      .child(uid)
      //.child('api')
      .child(type)
      //.child('classement')
      //.child('data')

      //.orderByChild('type')
      //.equalTo('web')
      .on('value', snapshot => {
        const data = snapshot.val() || {}
        const posts = Object.keys(data)
          .map(id => new Provider(id, data[id]))
          //.sort((lhs, rhs) => rhs.date.getTime() - lhs.date.getTime())

        postsObservable.next(posts)
      })*/

    return postsObservable
  }

  postsForUser(uid, type): Observable<any[]> {
    
    //const postsObservable = new FirebaseListObservable<Post[]>(null)
    
    //this.filteredPosts = new FirebaseListObservable<any[]>(null)
    
    
    //postsObservable.next(filteredPosts)

    
    /*const postsObservable = new BehaviorSubject<Post[]>(null)

    this.rootRef
      .child('coverage-feed')
      .child(uid)
      //.child(datenow)
      .child(type)
      //.orderByChild('type')
      //.equalTo('web')
      .limitToLast(30)
      .on('value', snapshot => {
        const data = snapshot.val() || {}
        const posts = Object.keys(data)
          .map(id => new Post(id, data[id]))
          .sort((lhs, rhs) => rhs.date.getTime() - lhs.date.getTime())

        postsObservable.next(posts)
      })
    */
    return this.af.list('/coverage-feed/'+uid+'/'+type).valueChanges();
  }

  toggleFavorite(userUid: string = '', post: any) {
    const isAFavorite = post.favorites.indexOf(userUid) !== -1
    
    /*const favorites = isAFavorite ?
      post.favorites.filter(uid => uid !== userUid) :
      [...post.favorites, userUid]

    this.rootRef
      .child('feed')
      .child(post.id)
      .child('favorites')
      .set(favorites)*/
  }
  
  toggleTopic(userUid, post) {
    //const isAFavorite = post.favorites.indexOf(userUid) !== -1
    
    //const post = post
    
    //var coverage = post.data.coverage
    

    /*this.rootRef
      .child('coverage-feed')
      .child(post.coverage[0].id)
      //.child(datenow)
      .child('aware')
      .child(post.id)
      //.child('favorites')
      .set(post)*/
  }
}


// WEBPACK FOOTER //
// ./src/services/post.service.ts